import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useLiveRefresh } from "@/hooks/useLiveRefresh";

const Ctx = createContext(null);

export function AnnouncementsProvider({ children }) {
  const [data, setData] = useState({ items: [], can_post_workspace: false, postable_projects: [] });
  const [loaded, setLoaded] = useState(false);

  const reload = useCallback(
    () => api.get("/announcements", { params: { tz_offset: -new Date().getTimezoneOffset() } }).then((res) => setData(res.data)).catch(() => {}).finally(() => setLoaded(true)),
    [],
  );
  useEffect(() => { reload(); }, [reload]);
  useLiveRefresh(reload, { interval: 60000 });

  const acknowledge = useCallback(async (id) => {
    setData((d) => ({ ...d, items: d.items.map((a) => (a.id === id ? { ...a, acknowledged: true } : a)) }));
    await api.post(`/announcements/${id}/ack`).catch(() => {});
  }, []);

  const setPoll = useCallback((id, poll) => {
    setData((d) => ({ ...d, items: d.items.map((a) => (a.id === id ? { ...a, poll } : a)) }));
  }, []);

  const unread = data.items.filter((a) => a.active && !a.acknowledged).length;
  return <Ctx.Provider value={{ ...data, loaded, reload, acknowledge, setPoll, unread }}>{children}</Ctx.Provider>;
}

export const useAnnouncements = () => useContext(Ctx);
